import React, { useState } from 'react';

const dotStyle = (color) => ({
  display: 'inline-block',
  width: 12,
  height: 12,
  borderRadius: '50%',
  background: color,
  border: '2px solid rgba(255,255,255,0.15)',
  marginRight: 8,
  flexShrink: 0,
});

const lineStyle = (color) => ({
  display: 'inline-block',
  width: 20,
  height: 3,
  background: color,
  borderRadius: 2,
  marginRight: 8,
  flexShrink: 0,
});

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  padding: '3px 0',
};

const sectionTitleStyle = {
  fontWeight: 700,
  fontSize: 11,
  marginTop: 8,
  marginBottom: 4,
  color: '#94a3b8',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
};

const MapLegend = ({ showNightLights = false }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={{
      position: 'absolute',
      bottom: 12,
      left: 12,
      background: 'rgba(15, 23, 42, 0.92)',
      backdropFilter: 'blur(12px)',
      borderRadius: 14,
      padding: collapsed ? '10px 14px' : '12px 16px',
      color: '#e2e8f0',
      fontSize: 12,
      fontFamily: 'system-ui, -apple-system, sans-serif',
      zIndex: 10,
      boxShadow: '0 4px 24px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.06)',
      minWidth: collapsed ? 100 : 210,
      maxHeight: 'calc(100vh - 340px)',
      overflowY: 'auto',
      userSelect: 'none',
      transition: 'all 0.25s ease',
    }}>
      {/* Header -- click to collapse */}
      <div
        onClick={() => setCollapsed(!collapsed)}
        style={{
          fontWeight: 700,
          fontSize: 13,
          marginBottom: collapsed ? 0 : 6,
          borderBottom: collapsed ? 'none' : '1px solid rgba(255,255,255,0.08)',
          paddingBottom: collapsed ? 0 : 6,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <span>Legend</span>
        <span style={{ fontSize: 10, color: '#64748b', transition: 'transform 0.2s', transform: collapsed ? 'rotate(-90deg)' : 'rotate(0deg)' }}>
          ▼
        </span>
      </div>

      {!collapsed && (
        <>
          {/* AADT colour scale */}
          <div style={sectionTitleStyle}>Traffic (AADT)</div>
          <div style={rowStyle}><span style={dotStyle('#22c55e')} /> &lt; 15,000</div>
          <div style={rowStyle}><span style={dotStyle('#eab308')} /> 15,000 – 30,000</div>
          <div style={rowStyle}><span style={dotStyle('#f97316')} /> 30,000 – 60,000</div>
          <div style={rowStyle}><span style={dotStyle('#ef4444')} /> &gt; 60,000</div>

          {/* Marker types */}
          <div style={sectionTitleStyle}>Markers</div>
          <div style={rowStyle}><span style={{ marginRight: 8, fontSize: 14 }}>📍</span> Subject Property</div>
          <div style={rowStyle}><span style={{ marginRight: 8, fontSize: 14 }}>⛽</span> Gas Station</div>
          <div style={rowStyle}><span style={{ marginRight: 8, fontSize: 14 }}>🏪</span> C-Store</div>

          {/* Other */}
          <div style={sectionTitleStyle}>Other</div>
          <div style={rowStyle}><span style={lineStyle('#22c55e')} /> Sensor connection line</div>
          <div style={rowStyle}><span style={dotStyle('#ff6b00')} /> Competitor heatmap</div>

          {/* Alcohol zones */}
          <div style={sectionTitleStyle}>Permit Zones</div>
          <div style={rowStyle}><span style={dotStyle('#f97316')} /> Church buffer (100 yd)</div>
          <div style={rowStyle}><span style={dotStyle('#dc2626')} /> School buffer (200 yd)</div>

          {/* Radius rings */}
          <div style={sectionTitleStyle}>Radius</div>
          <div style={rowStyle}><span style={lineStyle('#3b82f6')} /> 1 mile</div>
          <div style={rowStyle}><span style={lineStyle('#8b5cf6')} /> 3 miles</div>
          <div style={rowStyle}><span style={lineStyle('#6366f1')} /> 5 miles</div>

          {/* Night Lights gradient */}
          {showNightLights && (
            <>
              <div style={sectionTitleStyle}>Night Lights</div>
              <div style={{
                height: 12,
                borderRadius: 4,
                background: 'linear-gradient(to right, #6b21a8, #2563eb, #06b6d4, #eab308, #f97316, #dc2626)',
                margin: '4px 0',
              }} />
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: 10,
                color: '#94a3b8',
              }}>
                <span>Low</span>
                <span>Radiance (nW/cm²/sr)</span>
                <span>High</span>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default MapLegend;
